import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, catchError } from "rxjs";
import { environment } from "src/environments/environment";
import { CommonService } from "../../common-service";
import { VerifyUsersActiveResponse } from "../../responses/orchestrator-schedule/verify-users-active.response";

@Injectable({
    providedIn: 'root'
})
export class ListUserScheduleService extends CommonService {

    constructor(private httpClient: HttpClient) { super(); }

    public GetVerifyUserActives(idSpecialty: number): Observable<VerifyUsersActiveResponse> {

        let uri = `ListUserSchedule/VerifyUserActives/idSpecialty/${idSpecialty}`;

        return this.httpClient.get<VerifyUsersActiveResponse>(environment.urlApiOrchestratorSchedule + uri, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}